import { Component } from 'react';
import { connect } from 'react-redux';
import clsx from 'clsx';
import HeightAnimation from '@/animations/height';
import LoadingCircle from '@/components/loading-circle';
import Article from '@/components/article';
import Banner from '@/components/banner';
import Header from '@/components/header';
import LandingPageLoader from '@/components/landing-page/components/loader';
import Footer from '@/components/footer/footer.component';
import UploadForm from '@/components/upload-form';
import ThanksPage, { calculateDebtAnalysis } from '@/components/thanks-page';
import ResultPage from '@/components/result-page';
import LandingPage from '@/components/landing-page';
import SuccessGambling from '@/components/success-gambling';
import UploadFormSuccess from '@/components/upload-form-success/upload-form-success';
import SuccessText from '@/components/succes-text/success-text.component';
import Slider from '@/components/slider/slider';
import Uploader from '@/components/uploader/uploader';
import Modal from '@/components/modal/modal';
import sendFormData from '@/services/Api/send-form-data';
import { openUrl, setRoute } from '@/utils/helper';
import { UserFormSlice } from '@/redux/user-form';
import { ConfigSlice } from '@/redux/config';
import { DialogSlice } from '@/redux/dialog';
import { GeneralSlice } from '@/redux/general';
import { ModalSlice } from '@/redux/modal';
import { SliderSlice } from '@/redux/slider';
import Condition from '@/utils/condition';
import { CONFIG } from '@/utils/constants';
import { getClientSecretTargetUrl, whichUrlShouldBePassed, addRandomInsoPrice } from '@/utils/utils';
import Qid from '@/utils/qid';
import { getPath } from '@/utils/slide';
import MouseFlow from '@/utils/mouse-flow';
import Track from '@/utils/track';
import UrlQuery from '@/utils/url-query';
import { ID } from '@/utils/enums';
import '@/components/app/app-v1.css';
import '@/components/app/app-v2.css';

// Singleton bootstrap: the constructor seeds the QID cookie and wires Convert BYOID and CMP.
// Nothing here reads the instance — send-form-data.js gets the same one via `new Qid()`.
new Qid();

class App extends Component {
  constructor(props) {
    super(props);
  }

  preserveDankePhpPageState = () => {
    if (window.location.pathname.indexOf('/danke.php') >= 0) {
      if (UrlQuery.get('state').string() === 'yes') {
        const secret = UrlQuery.get('secret').string();
        const longReadLead = UrlQuery.get('longReadLead').number();
        this.props.setFormUploadCompleted(false);
        this.props.setFormUploadLoading(false);
        this.props.setDynamicLandingPageState('done');
        this.props.setIsFormSubmissionSuccessful(true);
        this.props.setIsFormSubmitted(true);
        this.props.setSecret(secret);
        this.props.setClientSecretUrl(
          getClientSecretTargetUrl(whichUrlShouldBePassed(location.href)).replace('{clientSecretId}', secret),
        );
        this.props.setLongReadLead(longReadLead);
        this.props.setShowNewTanksPage(this.props.useThanksPageWithCalculation);
      }
    } else {
      this.props.sliderToInitialState();
      this.props.generalToInitialState();
      this.props.userFormToInitialState();
    }
  };

  componentDidMount() {
    this.preserveDankePhpPageState();
    window.addEventListener(
      'popstate',
      (event) => {
        event.preventDefault();
        this.onBackButton();
        return false;
      },
      false,
    );
    this.props.setWindowLocationSearch(window.location.search);

    if (location.hash.length > 0) {
      if (location.hash.indexOf('datenschutz') > -1) {
        this.props.openBigTopCenterDialog('privacy-policy.dialog');
      }
      if (location.hash.indexOf('impressum') > -1) {
        this.props.openBigTopCenterDialog('imprint.dialog');
      }
    }

    setTimeout(function () {
      let event;

      try {
        event = new Event('resize');
      } catch (e) {
        // invalid constructor .... browser only supports legacy API
        event = document.createEvent('Event');
        event.initEvent('resize', false, true);
      }
      window.dispatchEvent(event);
    }, 1);

    if (window.location.pathname.search(/datenschutz/i) !== -1) {
      this.props.openBigTopCenterDialog('imprint.dialog');
    }

    if (window.location.pathname.search(/impressum/i) !== -1) {
      this.props.openModal({ main: <PrivacyPolicyMain /> });
    }

    const deleteMe = document.getElementById('deleteme');
    if (deleteMe) {
      deleteMe.remove();
    }

    this.props.setFormUploadSuccessful(UrlQuery.get('formUpload').string() === '1');

    setRoute({
      done: false,
      session: this.props.session,
      search: this.props.windowLocationSearch,
      setSearch: this.props.setWindowLocationSearch,
    });
  }

  componentWillUnmount() {
    window.removeEventListener('popstate', this.onBackButton);
  }

  afterChange = () => {
    const { currentQuestionId } = this.props;
    const dataKey = this.props.questionsVisible[currentQuestionId].key;
    const slideType = this.props.questionsVisible[currentQuestionId].type;

    if (dataKey === 'submit' || slideType === 'submission') {
      Track.Experiments.ToForm();
    } else if (dataKey === 'zip') {
      Track.DataLayer.AccessZip();
    }
  };

  resetSlider = () => {
    const { currentQuestionId } = this.props;
    if (currentQuestionId === 0) return;

    this.props.setCurrentQuestionId(0);
    this.props.setFormUploadSuccessful(false);

    this.props.resetCurrentQuestionId();
    this.props.resetAnswersDirect();
    setRoute({
      done: false,
      session: this.props.session,
      search: this.props.windowLocationSearch,
      setSearch: this.props.setWindowLocationSearch,
    });
  };

  nextSlide = (trigger, value) => {
    const { questionsVisible } = this.props;
    let slides = questionsVisible;
    let stateData = {};
    const slide = slides[this.props.currentQuestionId];
    const currentPath = getPath(slide, value);

    if (typeof currentPath === 'string') {
      openUrl(currentPath);
      return;
    }

    Track.Experiments.FunnelIncome();

    if (currentPath) {
      stateData.path = currentPath;
      const currentSlides = slides.slice(0, this.props.currentQuestionId + 1);

      slides = stateData.path.map((slideKey) => this.props.questionsAll.find((question) => question.key === slideKey));
      const mergedSlides = currentSlides.concat(slides);
      this.props.setQuestionsVisible(mergedSlides);
    }

    if (slide.tracking && slide.tracking.value === value) {
      Track.Experiments.BussgeldcheckManualActivation();
    }

    // set path and slides new if root question is being answered/changed
    if (slide.hasOwnProperty('overwrites') && slide.overwrites !== '') {
      this.props.setAnswersDirectByKey({ key: slide.overwrites, value });
    }

    const eventAction = slide.label === undefined ? slide.key : slide.label;

    const dataLabel = slide.choices && slide.choices.find((choice) => choice.value === value);
    let eventLabel = dataLabel && dataLabel.icon ? dataLabel.icon : '';

    if (slide.type !== 'multiple') {
      eventLabel = 'master';
    }

    if (slide.type === 'multiple-text') {
      eventLabel = dataLabel.value;
    }

    if (slide.type === 'text') {
      eventLabel = value;
    }

    if (eventAction === 'fuehrerschein-angewiesen') {
      eventLabel = dataLabel.value;
    }

    if (eventAction === 'zip') {
      eventLabel = value;
    }

    Track.DataLayer.Question(eventAction, eventLabel);

    this.props.setCurrentQuestionId(this.props.currentQuestionId + 1);
    setRoute({
      done: false,
      session: this.props.session,
      search: this.props.windowLocationSearch,
      setSearch: this.props.setWindowLocationSearch,
    });
  };

  prevSlide = () => {
    this.props.setFormUploadSuccessful(false);
    this.props.setCurrentQuestionId(this.props.currentQuestionId - 1);
    setRoute({
      done: false,
      session: this.props.session,
      search: this.props.windowLocationSearch,
      setSearch: this.props.setWindowLocationSearch,
    });
  };

  onBackButton() {
    if (this.props.isFormSubmitted) {
      window.location.href = '/';
    } else if (this.props.currentQuestionId === 0) {
      window.history.back();
    } else {
      this.prevSlide();
    }
  }

  isNewClient = () => {
    if (this.props.isNewClient) return this.props.isNewClient;
    const isNewClient = Math.random() <= this.props.newClientPercentToShow;
    this.props.setIsNewClient(isNewClient);
    return isNewClient;
  };

  onSubmit = (userForm) => {
    const { answersDirect } = this.props;

    const formData = Object.assign({}, answersDirect, userForm);

    // Reset redux forms
    // this.props.resetAnswersDirect() // TODO Check it out.
    this.props.resetCurrentQuestionId();

    if (this.props.newClientPercentToShow && this.isNewClient()) {
      formData.isNewClient = this.isNewClient();
    }

    this.props.setShowNewTanksPage(this.props.useThanksPageWithCalculation);

    // TODO: IS IT HERE ?
    if (this.props.useThanksPageWithCalculation) {
      const dataSa = calculateDebtAnalysis(formData);
      formData.data_sa = JSON.stringify(dataSa);
      formData.kinderanzahl = formData?.kinderanzahl?.length ? formData?.kinderanzahl : 0;
    }

    if (this.props.config[CONFIG.USE_INSO_PRICE_RANDOMIZER]) {
      addRandomInsoPrice(this.props.config, formData);
    }

    // Send form Data
    sendFormData(formData);
  };

  renderUploadForm() {
    const { isFormSubmitted, isFormSubmissionSuccessful, isFormSubmissionFailed, leadId, config } = this.props;
    const { useDynamicLandingPage, enabledUploadForm, useAlternateSuccessPage, alternateSuccessPageVersion } =
      this.props.config;

    // General LongRead
    if (isFormSubmitted && useDynamicLandingPage && this.props.percentDynamicLandingPageOnPrio) {
      if (this.props.dynamicLandingPageState === 'loading' && this.props.cssVersion === 1) {
        return (
          <div>
            <LandingPageLoader />
          </div>
        );
      }
      if ((this.props.prioV2 || this.props.prioV3 || this.props.prioGeneric) && this.props.longReadLead) {
        return <LandingPage version={this.props.dynamicLandingPageVersion} />;
      }
    }

    // New Thanks Page - schuldenanalyse
    if (this.props.showNewTanksPage) {
      MouseFlow.push('newPageView', '/debt-calculation-page');
      return <ThanksPage config={config} />;
    }

    // View with iframe success state
    if (this.props.formUploadCompleted) {
      return (
        <div className='loading-container'>
          {['SWE'].includes(Condition.getFirst(this.props.prefix, '')) ? (
            <HeightAnimation on={this.props.isFormSubmissionSuccessful}>
              <SuccessGambling
                answers={this.props.answersDirect}
                questions={this.props.questionsAll}
                fullName={this.props.fullName}
                email={this.props.email}
              />
            </HeightAnimation>
          ) : (
            <SuccessText />
          )}
        </div>
      );
    }

    // View with iframe loading state
    if (this.props.formUploadLoading) {
      return (
        <div className='loading-container' style={{ textAlign: 'center' }}>
          <div className='circle-loader' />
        </div>
      );
    }

    // View with iframe
    if (isFormSubmitted && enabledUploadForm === true && leadId) {
      MouseFlow.push('newPageView', '/form-upload-page');
      return <UploadForm />;
    }

    if (
      isFormSubmitted &&
      !useAlternateSuccessPage &&
      this.props.config['redirectToOnSubmit'] &&
      this.props.enableUploadFiles
    ) {
      MouseFlow.push('newPageView', '/files-upload-page');
      return (
        <div className='loading-container-files'>
          {isFormSubmissionSuccessful && !isFormSubmissionFailed ? (
            <>
              <div className='files-content'>
                <h1 className='files-content-title'>Bescheid hochladen</h1>
                <p className='files-content-info'>
                  Laden Sie bitte Fotos von Ihrem Bescheid hoch. Achten Sie darauf, dass Sie alle Seiten fotografieren,
                  jeweils die Vorder- und Rückseite.
                </p>
              </div>
              <Uploader />
            </>
          ) : (
            <LoadingCircle success={!!isFormSubmissionSuccessful} fail={!!isFormSubmissionFailed} />
          )}
        </div>
      );
    }

    if (isFormSubmitted && !useAlternateSuccessPage) {
      // Bussgeldcheck loading state
      return <ResultPage />;
    }

    // LongRead new version
    if (isFormSubmitted && useAlternateSuccessPage && alternateSuccessPageVersion) {
      MouseFlow.push('newPageView', '/alternate-success-page-' + alternateSuccessPageVersion);
      return <LandingPage version={alternateSuccessPageVersion} />;
    }

    return null;
  }

  onHeaderClick = () => {
    this.resetSlider();
    this.props.setFormUploadSuccessful(false);
  };

  render() {
    if (this.props.formUploadSuccessful) {
      return <UploadFormSuccess />;
    }

    return (
      <div
        data-page={this.props.page}
        data-css-version={this.props.cssVersion}
        data-sticky-header={this.props.enableStickyMobileHead && this.props.isLongReadShown}
        className='app'
      >
        <div className='app__container'>
          <div className={clsx('app__main', { 'app__main--full-height': this.props.withArticle })} id='content'>
            <Header onClick={this.onHeaderClick} />
            <div className='app__wrapper' id={ID.APP_WRAPPER}>
              <Banner />
              <Slider
                nextSlide={this.nextSlide}
                prevSlide={this.prevSlide}
                onSubmit={this.onSubmit}
                afterChange={this.afterChange}
              />
              {this.props.formUploadCompleted && (
                <LoadingCircle
                  success={!!this.props.isFormSubmissionSuccessful}
                  fail={!!this.props.isFormSubmissionFailed}
                  className='loadingCircle'
                />
              )}
              <div id='form'>{this.renderUploadForm(this.props.cssVersion)}</div>
            </div>
          </div>
          <Article />
          <Footer />
          <Modal />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // Slider Slice
  answersDefault: SliderSlice.selectors.answersDefault(state),
  isFormSubmitted: SliderSlice.selectors.isFormSubmitted(state),
  isFormSubmissionSuccessful: SliderSlice.selectors.isFormSubmissionSuccessful(state),
  isFormSubmissionFailed: SliderSlice.selectors.isFormSubmissionFailed(state),
  questionsVisible: SliderSlice.selectors.questionsVisible(state),
  currentQuestionId: SliderSlice.selectors.currentId(state),
  answersDirect: SliderSlice.selectors.answersDirect(state),
  questionsAll: SliderSlice.selectors.questionsAll(state),
  // UserForm Slice
  fullName: UserFormSlice.selectors.fullName(state),
  email: UserFormSlice.selectors.email(state),
  // Config Slice
  config: ConfigSlice.selectors.config(state),
  cssVersion: ConfigSlice.selectors.cssVersion(state),
  prefix: ConfigSlice.selectors.prefix(state),
  newClientPercentToShow: ConfigSlice.selectors.newClientPercentToShow(state),
  enableStickyMobileHead: ConfigSlice.selectors.headerEnableStickyMobileHead(state),
  questionsDefaultValues: ConfigSlice.selectors.questionsDefaultValues(state),
  dynamicLandingPageVersion: ConfigSlice.selectors.dynamicLandingPageVersion(state),
  enableUploadFiles: ConfigSlice.selectors.enableUploadFiles(state),
  useThanksPageWithCalculation: ConfigSlice.selectors.useThanksPageWithCalculation(state),
  percentDynamicLandingPageOnPrio: ConfigSlice.selectors.percentDynamicLandingPageOnPrio(state),
  prioCalculatorVersion: ConfigSlice.selectors.prioCalculatorVersion(state),
  // General Slice
  extendedSliderHeight: GeneralSlice.selectors.extendedSliderHeight,
  isLongReadShown: GeneralSlice.selectors.isLongReadShown(state),
  windowLocationSearch: GeneralSlice.selectors.windowLocationSearch(state),
  session: GeneralSlice.selectors.session(state),
  leadId: GeneralSlice.selectors.leadId(state),
  clientSecretUrl: GeneralSlice.selectors.clientSecretUrl(state),
  withArticle: GeneralSlice.selectors.withArticle(state),
  prioV2: GeneralSlice.selectors.prioV2(state),
  prioV3: GeneralSlice.selectors.prioV3(state),
  prioGeneric: GeneralSlice.selectors.prioGeneric(state),
  longReadLead: GeneralSlice.selectors.longReadLead(state),
  formUploadCompleted: GeneralSlice.selectors.formUploadCompleted(state),
  formUploadLoading: GeneralSlice.selectors.formUploadLoading(state),
  formUploadSuccessful: GeneralSlice.selectors.formUploadSuccessful(state),
  dynamicLandingPageState: GeneralSlice.selectors.dynamicLandingPageState(state),
  isNewClient: GeneralSlice.selectors.isNewClient(state),
  page: GeneralSlice.selectors.page(state),
  showNewTanksPage: GeneralSlice.selectors.showNewTanksPage(state),
});

const mapDispatchToProps = (dispatch) => ({
  // Slider Slice
  setAnswersDirectByKey: (keyValue) => dispatch(SliderSlice.actions.setAnswersDirectByKey(keyValue)),
  resetAnswersDirect: () => dispatch(SliderSlice.actions.resetAnswersDirect()),
  setIsFormSubmissionSuccessful: (isSuccessful) =>
    dispatch(SliderSlice.actions.setIsFormSubmissionSuccessful(isSuccessful)),
  setIsFormSubmitted: (isFormSubmitted) => dispatch(SliderSlice.actions.setIsFormSubmitted(isFormSubmitted)),
  setQuestionsVisible: (list) => dispatch(SliderSlice.actions.setQuestionsVisible(list)),
  setCurrentQuestionId: (id) => dispatch(SliderSlice.actions.setCurrentQuestionId(id)),
  resetCurrentQuestionId: () => dispatch(SliderSlice.actions.resetCurrentQuestionId()),
  sliderToInitialState: () => dispatch(SliderSlice.actions.toInitialState()),
  // General Slice
  setWindowLocationSearch: (search) => dispatch(GeneralSlice.actions.setWindowLocationSearch(search)),
  setSecret: (secret) => dispatch(GeneralSlice.actions.setSecret(secret)),
  setClientSecretUrl: (clientSecretUrl) => dispatch(GeneralSlice.actions.setClientSecretUrl(clientSecretUrl)),
  generalToInitialState: () => dispatch(GeneralSlice.actions.toInitialState()),
  setFormUploadCompleted: (state) => dispatch(GeneralSlice.actions.setFormUploadCompleted(state)),
  setFormUploadSuccessful: (state) => dispatch(GeneralSlice.actions.setFormUploadSuccessful(state)),
  setFormUploadLoading: (state) => dispatch(GeneralSlice.actions.setFormUploadLoading(state)),
  setLongReadLead: (longReadLead) => dispatch(GeneralSlice.actions.setLongReadLead(longReadLead)),
  setDynamicLandingPageState: (state) => dispatch(GeneralSlice.actions.setDynamicLandingPageState(state)),
  setIsNewClient: (state) => dispatch(GeneralSlice.actions.setIsNewClient(state)),
  setShowNewTanksPage: (showNewTanksPage) => dispatch(GeneralSlice.actions.setShowNewTanksPage(showNewTanksPage)),
  // UserForm Slice
  userFormToInitialState: () => dispatch(UserFormSlice.actions.toInitialState()),
  // Dialog Slice
  openBigTopCenterDialog: (name) => dispatch(DialogSlice.actions.openBigTopCenterDialog(name)),
  // Modal Slice
  openModal: (content) => dispatch(ModalSlice.actions.openModal(content)),
});

export default connect(mapStateToProps, mapDispatchToProps)(App);
